/**
 * WebSyncEventBus — browser implementation of SyncEventBus.
 *
 * Wraps CustomEvent dispatch + addEventListener for sync state changes.
 */

import type { SyncEventBus, SyncState } from "../../types";

const SYNC_STATE_EVENT = "caliu:sync-state";

export class WebSyncEventBus implements SyncEventBus {
  emit(event: "sync-state", state: SyncState): void {
    if (event === "sync-state") {
      window.dispatchEvent(
        new CustomEvent(SYNC_STATE_EVENT, { detail: state }),
      );
    }
  }

  subscribe(
    event: "sync-state",
    callback: (state: SyncState) => void,
  ): () => void {
    if (event === "sync-state") {
      const handler = (e: Event) => {
        callback((e as CustomEvent<SyncState>).detail);
      };
      window.addEventListener(SYNC_STATE_EVENT, handler);
      return () => window.removeEventListener(SYNC_STATE_EVENT, handler);
    }
    return () => {};
  }
}
